import { createServiceStore } from 'common/store';
import { initialState } from './constants';
export var useBenefitConversionStore = createServiceStore({
    initialValues: initialState,
});
